import { useState, useEffect } from 'react'

interface UseImageLoaderProps {
  images: string[]
}

export function useImageLoader({ images }: UseImageLoaderProps) {
  const [loadedImages, setLoadedImages] = useState<Set<string>>(new Set())
  const [isLoading, setIsLoading] = useState(true)
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    if (images.length === 0) {
      setIsLoading(false)
      setProgress(100)
      return
    }

    const loadImage = (src: string): Promise<void> => {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve()
        img.onerror = () => reject(new Error(`Failed to load image: ${src}`))
        img.src = src
      })
    }

    const loadAllImages = async () => {
      try {
        setIsLoading(true)
        setProgress(0)
        setLoadedImages(new Set())
        
        let loadedCount = 0
        const promises = images.map(async (src) => {
          await loadImage(src)
          loadedCount++
          setProgress((loadedCount / images.length) * 100)
          setLoadedImages(prev => new Set([...Array.from(prev), src]))
        })
        
        await Promise.all(promises)
        setIsLoading(false)
      } catch (error) {
        console.error('Erro ao carregar imagens:', error)
        // Mesmo com erro, continuar para não travar a página
        setIsLoading(false)
        setProgress(100)
      }
    }

    loadAllImages()
  }, [images])

  return { isLoading, loadedImages, progress }
} 